import React, {PropsWithChildren, ReactElement, useEffect} from 'react';
import {Route} from 'react-router-dom';
import {useAuth} from "react-oidc-context";
import ApiClient from "../services/ApiClient";
import WithCompanyAccountContext from "../components/contexts/WithCompanyAccountContext";

export default function PrivateRoute({ children, path, exact }: PropsWithChildren<{ path: string; exact: boolean }>): ReactElement {
  const auth = useAuth();


  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator) {
      auth.signinRedirect({
        state: { returnTo: window.location.pathname + window.location.search }
      });
    }
    if(auth.user && ApiClient){
      ApiClient.setAccessTokenProvider(() => auth.user?.access_token)
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth]);

  return (
    <Route
      path={path}
      exact={exact}
      render={() => {
        if (auth.isLoading) return <div>Loading..</div>;
        if (auth.error) return <div>Error: {auth.error.message}</div>;
        if (!auth.isAuthenticated) return <div>Redirecting...</div>;

        return <WithCompanyAccountContext>{children}</WithCompanyAccountContext>;
      }}
    />
  );
}
